module.exports = __webpack_public_path__ + "img/cowoo.07ed8c6a.png";